(function () {
  'use strict';
  // Published tiers, not a volume-to-stocking extrapolation. See page sources.
  const tiers = [{width:90,depth:60,height:120,capacity:5},{width:93,depth:63,height:123,capacity:10}];
  function check(input) {
    if (!['cm','in'].includes(input.units)) return {error:'Choose centimetres or inches.'};
    const names = ['width','depth','height','bars','rats'];
    const values = Object.fromEntries(names.map(k => [k, Number(input[k])]));
    const invalid = names.filter(k => String(input[k] ?? '').trim() === '' || !Number.isFinite(values[k]) || values[k] <= 0 || (k === 'rats' && !Number.isSafeInteger(values[k])));
    if (invalid.length) return {error:'Enter a positive measurement in every box and a whole number of rats.',invalid};
    const factor = input.units === 'in' ? 2.54 : 1;
    const [width,depth] = [values.width*factor,values.depth*factor].sort((a,b)=>b-a);
    const height=values.height*factor, bars=values.bars*factor;
    // Tiny floating-point tolerance is for exact unit conversion, not rounding a short cage up.
    const atLeast=(a,b)=>a >= b || Math.abs(a-b) <= Number.EPSILON*Math.max(a,b)*8;
    let capacity=0;
    tiers.forEach(t=>{if(atLeast(width,t.width)&&atLeast(depth,t.depth)&&atLeast(height,t.height))capacity=t.capacity;});
    const barOK=atLeast(1,bars), groupOK=values.rats>=2, withinRange=values.rats<=capacity;
    const supported=capacity>0&&barOK&&groupOK&&withinRange;
    let verdict;
    if(!capacity)verdict='Too small for the published guidance';
    else if(!barOK)verdict='Big enough, but the bar gaps are too wide';
    else if(!groupOK)verdict='Big enough, but rats need company';
    else if(!withinRange)verdict='Too small for this many rats';
    else verdict='Meets the size and bar-gap checks for '+values.rats+' rats';
    return {capacity,barOK,groupOK,supported,verdict,rats:values.rats};
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={check};
  if(typeof document==='undefined')return;
  function mount(root){
    if(root.dataset.fitMounted)return;
    root.dataset.fitMounted='true';
    const form=root.querySelector('[data-fit-form]'),result=root.querySelector('[data-fit-result]');
    if(!form||!result)return;
    form.hidden=false;
    let currentUnit=form.elements.units.value;
    function show(data){
      result.replaceChildren();
      const heading=document.createElement('h2');heading.textContent=data.error||data.verdict;result.append(heading);
      if(data.error)return;
      const lines=[data.capacity?'Big enough for 2 to '+data.capacity+' rats by the published guidance. That is a guide, not a hard limit.':'Too small for any group: the guidance asks for at least 90 × 60 × 120 cm for two to five rats.',
        data.barOK?'Bar gaps: 1 cm or less, which is what the guidance asks for. Still check doors and corners for wider gaps.':'Bar gaps: wider than the 1 cm the guidance asks for. Smaller or younger rats may squeeze through.',
        'Size is only part of a good home: airflow, safe levels and things to do matter too.'];
      if(!data.groupOK)lines.push('Rats need other rats for company. Blue Cross recommends pairs or groups; Woodgreen ideally recommends at least three. If a rat has to live alone, ask a rat-experienced rescue or vet.');
      if(data.rats>data.capacity&&data.capacity)lines.push('This cage is too small for that many rats by the published guidance. A larger cage is needed; the guidance stops at ten rats, so bigger groups need individual advice.');
      lines.forEach(text=>{const p=document.createElement('p');p.textContent=text;result.append(p);});
    }
    form.elements.units.addEventListener('change',()=>{
      const next=form.elements.units.value, factor=currentUnit===next?1:next==='in'?1/2.54:2.54;
      ['width','depth','height','bars'].forEach(k=>{const el=form.elements[k];if(el.value&&Number.isFinite(Number(el.value)))el.value=String(Math.round(Number(el.value)*factor*100)/100);});
      currentUnit=next;
      root.querySelectorAll('[data-fit-unit]').forEach(el=>el.textContent=next);
      result.replaceChildren();const p=document.createElement('p');p.textContent='Measurements converted. Check cage fit again.';result.append(p);
    });
    form.addEventListener('input',()=>{result.replaceChildren();const p=document.createElement('p');p.textContent='Measurements changed. Check cage fit again.';result.append(p);});
    form.addEventListener('submit',event=>{
      event.preventDefault();
      ['width','depth','height','bars','rats'].forEach(k=>form.elements[k].removeAttribute('aria-invalid'));
      const data=check(Object.fromEntries(new FormData(form)));show(data);
      if(data.invalid){data.invalid.forEach(k=>form.elements[k].setAttribute('aria-invalid','true'));form.elements[data.invalid[0]].focus();}
      else result.focus();
    });
  }
  document.querySelectorAll('[data-rn-cage-fit]').forEach(mount);
  document.addEventListener('shopify:section:load',e=>{e.target.querySelectorAll('[data-rn-cage-fit]').forEach(mount);});
})();
